import { FreeTextContainer } from "./style";

const FormFreeText = ({ flag, setFlag }) => {
  return (  
    <FreeTextContainer value={flag} onChange={(e) => setFlag(e.target.value)} placeholder="Write your answer here..."></FreeTextContainer>
  );
}
 
export default FormFreeText;
